import { Action, deleteInvocesToken, saveToken, Trigger } from '../../defaults';

export const changeHashMapParamTriggers: Trigger[] = [
  {
    events: ['on-change-any-hash-map-param'],
    targets: [saveToken],
    handlers: ['resolve-save-button-disabled'],
  },
];

export const changeHashMapParamActions: Action[] = [
  {
    kind: 'changes',
    token: 'resolve-save-button-disabled',
    spec: {
      target: saveToken,
      changes: {
        'data.disabled': {
          type: 'func',
          value: `({hashMap}) => {
  const isDeleteInvoces = !!hashMap['${deleteInvocesToken}'].data.value.length

  const hashMapArr = Object.values(hashMap)
  let numberOfInputs = 0
  const isNotValidItems = !!hashMapArr.filter(({spec, data, meta}) => {
    if (spec.startsWith('input-') && !!meta?.validations?.length) numberOfInputs++

    return spec.startsWith('input-') && data.valid === false
  }).length

  if (!numberOfInputs && !isDeleteInvoces) return true

  return isNotValidItems
}`,
        },
      },
    },
  },
];
